<template>
  <div class="agentGrab">
    <div class="w-1140px mx-auto c3 tracking-2px pt-58px fs16">
      <div>
        <div class="text-center pb-40px">
          <p class="fs32 font-600">产品介绍</p>
          <p class="fs22 c9">Product Introduction</p>
        </div>
        <div class="flex justify-center items-center">
          <div class="pr-35px">
            <p class="font-500 fs26 pb-10px">无忧代理人</p>
            <p>
              是未斯科技依托自身运营的e航无忧国际物流综合服务平台所打造的一站式自助代理分销平台。<br />
              只需在线注册认证，由客服完成后台授权后，您就可以在后台自定义专属域名、网站名称、专属Logo和自行设置各个产品的对外卖价。
            </p>
            <el-button
              class="btn mt-32px fs20 lh10"
              type="primary"
              @click="openQQ"
              >立即体验</el-button
            >
          </div>
          <img
            class="ml-10px"
            width="414px"
            :src="`${ossUrl}/common/market_v2/home/agent-1.jpg`"
          />
        </div>
      </div>

      <div class="pt-80px">
        <div class="text-center pb-40px">
          <p class="fs32 font-600">无忧代理人权益</p>
          <p class="fs22 c9">Rights and Interests</p>
        </div>
        <div class="pt-40px">
          <p class="fs26">成为无忧代理人后，可以享受如下权益：</p>
          <div class="interestsContent flex flex-col flex-wrap h-840px">
            <div
              v-for="(v, i) in interests"
              :key="i"
              class="single flex w-354px h-216px pt-16px pl-16px bg-f2"
              :class="{
                'mt-190px': i === 0,
                'mb-72px': i !== interests.length - 1,
                'mt-40px': i === 2,
                'ml-440px': [2, 3, 4].includes(i),
              }"
            >
              <img class="h-26px mt-5px mr-8px" :src="v.img" />
              <div>
                <p class="fs24 font-500 mb-3px">{{ v.title }}</p>
                <p v-for="(t, ii) in v.txt" :key="ii">{{ t }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pt-80px pb-80px">
        <div class="text-center pb-55px">
          <p class="fs32 font-600">加入流程</p>
          <p class="fs22 c9">Application Process</p>
        </div>
        <ul class="processContent">
          <li class="pl-111px pt-167px">
            <p class="fs24 font-500">Step 1：账号注册及认证</p>
            <p>点击右上角“登录注册”完成注册及企业认证</p>
          </li>
          <li class="pl-569px pt-313px">
            <p class="fs24 font-500">Step 2：专属销售跟进</p>
            <p class="w-486px">
              您的专属销售代表将会和您联络完成签约授权，并与您洽谈我们提供的具有竞争力的成本报价
            </p>
          </li>
          <li class="pl-111px pt-326px">
            <p class="fs24 font-500">Step 3：配置管理后台</p>
            <p>进入“无忧代理人”管理后台配置品牌、域名、Logo基础信息</p>
          </li>
          <li class="pl-569px pt-326px">
            <p class="fs24 font-500">Step 4：设置产品定价</p>
            <p>进入“客户管理”—“产品定价”设置对外价格，开启推广</p>
          </li>
          <li class="pl-111px pt-396px">
            <p class="fs24 font-500">Step 5：提现当前收益</p>
            <p>为e航无忧开具发票，随时随地提现收益</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { openQQ } from '@/utils/common.js'
import { ossUrl } from '@/utils/config.js'
/**
 * 无忧代理人落地页
 */
export default {
  name: 'Agent',
  data() {
    return {
      ossUrl,
      interests: [
        {
          img: `${ossUrl}/common/market_v2/home/agent-icon-2.png`,
          title: '专属网站',
          txt: [
            '1、自定义专属域名',
            '2、网站名称',
            '3、专属Logo',
            '4、专属数据发送平台',
            '5、自定义售价',
          ],
        },
        {
          img: `${ossUrl}/common/market_v2/home/agent-icon-4.png`,
          title: '专家',
          txt: [
            '1、电销专家远程支持，支撑电销团队',
            '组建，官网Leads的电销指导与管理',
            '2、e航无忧运营专家，支持专职团队',
            '搭建，指导市场营销和拓展',
          ],
        },
        {
          img: `${ossUrl}/common/market_v2/home/agent-icon-1.png`,
          title: '官网展示',
          txt: ['e航无忧官网页面统一展示'],
        },
        {
          img: `${ossUrl}/common/market_v2/home/agent-icon-3.png`,
          title: '销售线索',
          txt: ['1、官网Leads派发', '2、商机共享'],
        },
        {
          img: `${ossUrl}/common/market_v2/home/agent-icon-5.png`,
          title: '培训赋能',
          txt: ['1、线上赋能平台', '2、线下专场培训'],
        },
      ],
    }
  },
  head() {
    return {
      title: '无忧代理人 - e航无忧',
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: '无忧代理人,e航无忧',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            'e航无忧为国际物流行业数字化转型提供了货代操作,货代系统,海运查询,船期查询,货物跟踪,数据发送,舱单发送等一站式智能化产品及解决方案。',
        },
      ],
    }
  },
  methods: {
    openQQ,
  },
}
</script>

<style lang="scss" scoped>
.bg-f2 {
  background-color: #f2f9ff;
}
.agentGrab {
  background-image: url(https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/rpa_2.0_home/banner-case.png);
  background-position: center calc(100% + 410px);
  background-repeat: no-repeat;
  line-height: 32px;
  .btn {
    width: 140px;
    height: 42px;
    background-color: #0f71ef;
    border-color: #0f71ef;
    border-radius: 4px;
  }
  .interestsContent {
    background-image: url(https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/home/agent-2.png);
    background-repeat: no-repeat;
    background-position-x: center;
    background-position-y: 154px;
    background-size: 427px 552px;
    .single {
      position: relative;
      z-index: 2;
      &::before {
        content: url(https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/home/agent-8.png);
        position: absolute;
        z-index: 1;
        top: -8px;
        right: -8px;
        opacity: 0;
        transition: opacity 0.6s;
      }
      &:hover {
        &::before {
          opacity: 1;
        }
      }
    }
  }

  .processContent {
    height: 2040px;
    background-image: url(https://uifox-public.oss-cn-hangzhou.aliyuncs.com/common/market_v2/home/agent-9.png);
    background-repeat: no-repeat;
    background-position-x: center;
    background-size: 1181px 2040px;
  }
}
</style>
